import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';

type Props = {
  items: {
    '@id': string;
    id: string;
    title: string;
  }[];
  isEditMode?: boolean;
};

export default function RelatedProducts({ items, isEditMode }: Props) {
  return (
    <div className="related-products-wrapper left">
      {items.filter(Boolean).map((item) => (
        <div className="item" key={item.id}>
          {/* @ts-ignore */}
          <ConditionalLink
            condition={!isEditMode}
            item={item}
            openLinkInNewTab={false}
          >
            {item.title}
          </ConditionalLink>
        </div>
      ))}
    </div>
  );
}
